<template>
  <div
    :class="[$root.isDarkMood ? 'menu_bar_bg' : 'dark_menu_bar_bg']"
    class="md:w-1/2 h-auto mx-auto mt-5"
  >
    <div
      :class="[$root.isDarkMood ? 'text-slate-50' : 'text-gray-700']"
      class="py-9 px-5"
    >
      <router-link
        to="/all_blogs"
        class="
          font-bold
          text-md
          md:text-xl
          flex
          justify-center
          items-center
          hover:text-blue-600
        "
      >
        <svg
          class="w-6 h-6"
          fill="none"
          stroke="currentColor"
          viewBox="0 0 24 24"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            stroke-linecap="round"
            stroke-linejoin="round"
            stroke-width="2"
            d="M15 19l-7-7 7-7"
          ></path>
        </svg>
        <p class="pl-4">How to host laravel project on Heroku for free?</p>
      </router-link>
      <p class="text-sm text-center my-8">
        Category
        <span class="bg-red-600 rounded-full px-1 text-white">Laravel</span>
      </p>
      <img
        src="../../public/images/hekokuLaravel.jpeg"
        class="md:w-4/5 mx-auto my-3 object-cover rounded-lg"
        alt=""
      />
      <div class="text-center md:flex justify-center space-x-4">
        <p class="text-sm md:text-base">You can read the full blog from this link.</p>
        <a
        class="text-blue-400 underline"
          target="_blank"
          href="https://medium.com/@nedsoft/how-to-host-a-laravel-app-with-mysql-database-on-heroku-ab56b08be735"
          >GO</a
        >
      </div>
    </div>
  </div>
</template>

<script>
export default {};
</script>

<style>
</style>